import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'react-feather';
import './IndoorCasepaper.css';
import PatientCCPaperView from '../../components/PatientCCPaperView/PatientCCPaperView';
import DoctorRoundHistory from './components/DoctorRoundHistory';
import ActionCard from './components/ActionCard';
import { useIndoorCasepaperLogic } from './hooks/useIndoorCasepaperLogic';

import { useSelector } from 'react-redux';
import { matchPermissions } from '../../utils/Permission';
import { PERMISSIONS } from '../../constants/permissions';

/**
 * IndoorCasepaper Main Page
 * Refactored for DRY, Modularity, and Performance.
 * Logic is delegated to useIndoorCasepaperLogic hook.
 * UI is split into smaller reusable components.
 */
const IndoorCasepaper = () => {
  const { userDetails } = useSelector(state => state?.auth);
  const matchPermission = matchPermissions(userDetails);
  const canView = matchPermission(PERMISSIONS.INDOOR_CASEPAPER.VIEW);

  const {
    id,
    isPatientPlanId,
    patientPlanList,
    roomName,
    roomType,
    cardData
  } = useIndoorCasepaperLogic();

  if (!canView) {
    return (
      <>
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content">
            <div className="permission-denied-message" style={{ textAlign: 'center', padding: '50px' }}>
              <h3>Permission Denied</h3>
              <p>You do not have permission to view this page.</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <Sidebar />
      <div className="indoor-casepaper-container">
        <div className="page-wrapper">
          <div className="content py-4">
            {/* Breadcrumb - Extracted to localized structure */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admin-dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <ChevronRight size={16} />
                    </li>
                    <li className="breadcrumb-item active">Indoor CasePaper</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Patient Overview Section */}
            <PatientCCPaperView
              userId={id}
              extraInfo={{
                "Treatment Name": patientPlanList?.treatmentName || '—',
                "Booking Type": (patientPlanList?.programSlotId) ? "Program" :
                  (patientPlanList?.solutionSlotId) ? "Solution" :
                    (patientPlanList?.serviceSlotId) ? "Service" : "Treatment",
                "Room No": roomName || '—',
                "Room Type": roomType || '—'
              }}
            />

            {/* Actions Section */}
            <div className="section-title-wrapper mt-4">
              <h2 className="section-title">Available Actions</h2>
              <p className="section-subtitle">Select an action to manage patient records</p>
            </div>

            <div className="action-cards-grid">
              {cardData.map(card => {
                // Filter logic for service slots
                if ([0, 2, 3, 4, 5].includes(card.id) && patientPlanList?.serviceSlotId) {
                  return null;
                }

                // Permission check
                if (card.hasPermission === false) {
                  return null;
                }

                return (
                  <ActionCard
                    key={card.id}
                    data={card}
                    isPatientPlanId={isPatientPlanId}
                  />
                );
              })}
            </div>

            {/* Historical Records Section */}
            {patientPlanList?.doctorRoundForm && Object.keys(patientPlanList.doctorRoundForm).length > 0 && (
              <div className="mt-4">
                <DoctorRoundHistory doctorRoundForm={patientPlanList.doctorRoundForm} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default IndoorCasepaper;
